"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserAssignment = void 0;
var constants_1 = require("../../constants");
/**
 * It contains information about the user assignment
 *
 * @property {string}             id                 - Unique identifier of the assignment
 * @property {StudentAssignment}  assignment         - Assignment the user assignment belongs to
 * @property {string}             districtId         - Unique identifier of the organization/institution the user assignment belongs to
 * @property {string}             schoolId           - Unique identifier of the school the assignment belongs to
 * @property {Date}               dueDate            - Date at which the user assignment was due
 * @property {string}             enrollmentPeriodId - Unique identifier of the enrollment period the assignment belongs to
 * @property {string}             assigneeId         - Unique identifier of the user the assignment was assigned to
 * @property {Date}               startedAt          - Date at which the user assignment was started
 * @property {Date}               completedAt        - Date at which the user assignment was completed
 * @property {string}             status             - Current state of the user assignment. Acceptable values: assigned, started, submitted
 *
 */
var UserAssignment = /** @class */ (function () {
    function UserAssignment(data) {
        if (data === void 0) { data = {}; }
        Object.assign(this, data);
    }
    Object.defineProperty(UserAssignment.prototype, "isInProgress", {
        get: function () {
            return this.status === constants_1.UserAssignmentStatus.InProgress;
        },
        enumerable: false,
        configurable: true
    });
    return UserAssignment;
}());
exports.UserAssignment = UserAssignment;
